import * as React from 'react';
import _ from 'lodash';
import searchTestIds from '../../SearchResults.elements';
import * as Styled from './styled';

const SearchTableHeader: React.FunctionComponent<any> = () => (
	<Styled.TableRowHeader data-id={searchTestIds.searchResultGridHeader}>
		<Styled.TableHeaderCell scope="col">
			Client name & ID
		</Styled.TableHeaderCell>
		<Styled.TableHeaderCell scope="col">Type</Styled.TableHeaderCell>
		<Styled.TableHeaderCell scope="col">Address</Styled.TableHeaderCell>
		<Styled.TableHeaderCell scope="col" align="right">
			Total balance
		</Styled.TableHeaderCell>
	</Styled.TableRowHeader>
);

export default SearchTableHeader;
